import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Redirect, Route, useHistory, useParams, withRouter } from 'react-router';
import TabsButton from 'layout/atoms/TabsButton/TabsButton';
import Grid from 'layout/molecules/Grid/Grid';
import { clearBreadcrumbs, setBreadcrumbs } from 'store/layoutSlice';
import Dashboard from 'templates/Dashboard/Dashboard';
import Brands from './Brands/Brands';
import Categories from './Categories/Categories';
import ExchangeRates from './ExchangeRates/ExchangeRates';
import Maintenance from './Maintenance/Maintenance';
import ModelDimensions from './ModelDimensions/ModelDimensions';
import ProductCategories from './ProductCategories/ProductCategories';
import ProductParameters from './ProductParameters/ProductParameters';
import Seasons from './Seasons/Seasons';
import Sizes from './Sizes/Sizes';
import Statuses from './Statuses/Statuses';
function SpecificationParametersDashboard() {
    const { t } = useTranslation(['specification', 'common', 'layout']);
    const dispatch = useDispatch();
    const history = useHistory();
    const params = useParams();
    const path = `/specification-parameters`;
    const [activeTab, setActiveTab] = useState('brands');
    useEffect(() => {
        dispatch(setBreadcrumbs([
            { to: '/specification-parameters', name: t('common:SIDEBAR_MENU_ADMINISTRATION') },
        ]));
        return () => {
            dispatch(clearBreadcrumbs());
        };
    }, [dispatch, t]);
    useEffect(() => {
        if (params === null || params === void 0 ? void 0 : params.tab) {
            setActiveTab(params.tab);
        }
        else {
            setActiveTab('brands');
        }
    }, [params.tab, activeTab]);
    const tabs = [
        {
            id: 'brands',
            label: t('brands'),
        },
        {
            id: 'categories',
            label: t('common:categories'),
        },
        {
            id: 'product',
            label: t('product_parameters'),
        },
        {
            id: 'product-category',
            label: t('product_categories'),
        },
        {
            id: 'seasons',
            label: t('seasons'),
        },
        {
            id: 'statuses',
            label: t('statuses'),
        },
        {
            id: 'sizes',
            label: t('sizes'),
        },
        {
            id: 'dimensions',
            label: t('model_dimensions'),
        },
        {
            id: 'exchange-rates',
            label: t('common:exchange_rates'),
        },
        {
            id: 'maintenance',
            label: t('common:maintenance'),
        },
    ];
    return (React.createElement(Dashboard, null,
        React.createElement(Grid, { vp: 12, hp: 24 },
            React.createElement(TabsButton, { activeTab: activeTab, tabs: tabs, onClick: (e) => history.push(`${path}/${e}`) }),
            React.createElement(Grid, { gap: 0 },
                React.createElement(Route, { exact: true, path: `${path}/brands` },
                    React.createElement(Brands, null)),
                React.createElement(Route, { exact: true, path: `${path}/categories` },
                    React.createElement(Categories, null)),
                React.createElement(Route, { exact: true, path: `${path}/product` },
                    React.createElement(ProductParameters, null)),
                React.createElement(Route, { exact: true, path: `${path}/product-category` },
                    React.createElement(ProductCategories, null)),
                React.createElement(Route, { exact: true, path: `${path}/seasons` },
                    React.createElement(Seasons, null)),
                React.createElement(Route, { exact: true, path: `${path}/statuses` },
                    React.createElement(Statuses, null)),
                React.createElement(Route, { exact: true, path: `${path}/sizes` },
                    React.createElement(Sizes, null)),
                React.createElement(Route, { exact: true, path: `${path}/dimensions` },
                    React.createElement(ModelDimensions, null)),
                React.createElement(Route, { exact: true, path: `${path}/exchange-rates` },
                    React.createElement(ExchangeRates, null)),
                React.createElement(Route, { exact: true, path: `${path}/maintenance` },
                    React.createElement(Maintenance, null)),
                React.createElement(Route, { path: `${path}` },
                    React.createElement(Redirect, { to: `${path}/brands` }))))));
}
export default memo(withRouter(SpecificationParametersDashboard));
